export default "__VITE_ASSET__664211c8__"